import api from "./client";
const competitionApi = {
    analyzeCompetition(data) {
        return api
            .post("/v1/rekabet/analyze", { ...data, source: "db" })
            .then((res) => res.data);
    },
    getLinePairDetail(hat1, hat2, distanceThreshold) {
        return api
            .post("/v1/rekabet/line-pair-detail", {
            source: "db",
            hat_1: hat1,
            hat_2: hat2,
            distance_threshold: distanceThreshold,
        })
            .then((res) => res.data);
    },
    getWhatIfScenarios(hat1, hat2, zamanDilimi, distanceThreshold) {
        return api
            .post("/v1/rekabet/what-if-scenarios", {
            source: "db",
            hat_1: hat1,
            hat_2: hat2,
            zaman_dilimi: zamanDilimi || undefined,
            distance_threshold: distanceThreshold,
        })
            .then((res) => res.data);
    },
    getStopComparison(data) {
        return api
            .post("/v1/rekabet/stop-comparison", { ...data, source: "db" })
            .then((res) => res.data);
    },
    exportCompetitionCsv(payload = {}) {
        return api
            .post("/v1/rekabet/export/csv", payload, {
            responseType: "blob",
        })
            .then((res) => res.data);
    },
    getAnalysisProgress(analysisId = "competition") {
        return api
            .get(`/v1/rekabet/progress?analysis_id=${analysisId}`)
            .then((res) => res.data);
    },
    getCompetitionHealth() {
        return api.get("/v1/rekabet/health").then((res) => res.data);
    },
    getOdLines(params = {}) {
        return api
            .get("/v1/rekabet/od-lines", { params })
            .then((res) => res.data);
    },
};
export default competitionApi;
